import React from 'react'
import Svg from '../Svg'
import { SvgProps } from '../types'

const Icon: React.FC<SvgProps> = ({ fill, ...props }) => {
  return (
    <Svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
      <path
        d="M1.75738 14.6786C1.33319 14.2832 1.33319 13.6111 1.75738 13.2157L4.94149 10.2476C5.58087 9.65159 6.62334 10.105 6.62334 10.9791L6.62335 16.9152C6.62335 17.7893 5.58087 18.2427 4.94149 17.6467L1.75738 14.6786Z"
        fill="white"
      />
      <rect x="4.74023" y="11.8496" width="13.7389" height="3.98486" rx="1.99243" fill="white" />
      <path
        d="M19.2446 5.66512C19.6688 6.06054 19.6688 6.73269 19.2446 7.1281L16.0605 10.0962C15.4211 10.6922 14.3786 10.2388 14.3786 9.36468L14.3786 3.42854C14.3786 2.55446 15.4211 2.10106 16.0605 2.69705L19.2446 5.66512Z"
        fill="white"
      />
      <rect
        x="16.2617"
        y="8.49414"
        width="13.7389"
        height="3.98486"
        rx="1.99243"
        transform="rotate(-180 16.2617 8.49414)"
        fill="white"
      />
    </Svg>
  )
}

export default Icon
